import { Link } from 'react-router-dom'
import { Bars3Icon } from '@heroicons/react/24/outline'

interface MobileTopBarProps {
  avatarUrl: string | null
  onMenuOpen: () => void
}

export function MobileTopBar({ avatarUrl, onMenuOpen }: MobileTopBarProps) {
  return (
    <div className="sticky top-0 z-30 flex items-center justify-between border-b border-app-line bg-app-surface px-4 py-3 lg:hidden">
      {/* Hamburger */}
      <button
        onClick={onMenuOpen}
        className="flex h-10 w-10 items-center justify-center rounded-lg text-app-muted hover:bg-app-subtle transition-colors"
        aria-label="Open menu"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>

      {/* Logo */}
      <Link to="/" className="inline-flex items-center transition hover:opacity-80">
        <img src="/logo-header-black.svg" alt="JobTrackr.it" className="h-8 w-auto dark:hidden" />
        <img src="/logo-header-white.svg" alt="JobTrackr.it" className="h-8 w-auto hidden dark:block" />
      </Link>

      {/* Avatar */}
      <Link
        to="/profile"
        className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-app-line bg-app-page hover:ring-2 hover:ring-app-accent/50 transition-all"
        aria-label="Go to profile"
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt="Avatar" className="h-full w-full object-cover" />
        ) : (
          <svg className="h-5 w-5 text-app-muted" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
        )}
      </Link>
    </div>
  )
}
